import React from "react";

export default function SectionContainerComponent({ children }) {
    return <div className="max-w-3xl mx-auto sm:px-6 xl:max-w-5xl xl:px-0">{children}</div>
}